<script lang="ts">
      import { getLocaleContext } from '$lib/components/locale/ts/Locale.svelte'
      import { addComma, renderEntity, roleAggregation } from '../ts/Program'

      let locale = getLocaleContext()

      let { entities } = $props()
</script>

{#each entities as ent, o}
      {@const entityObject = renderEntity(ent)}
      {#if entityObject.url}
            <a class="df-link" href={locale.getLocaleLink(entityObject.url)}>{entityObject.title}</a>
      {:else}
            {entityObject.title}
      {/if}
      {addComma(o, entities.length)}
{/each}
